import PropTypes from "prop-types";
import {
  HiOutlineDocumentText,
  HiOutlineCheckCircle,
  HiOutlineClock,
  HiOutlineExclamationTriangle,
} from "react-icons/hi2";
import useBatchDetail from "../hooks/useBatchDetail";
import BulkStatCard from "../components/cards/BulkStatCard";
import { getDisplayValue } from "../../../utils/transactionutils";

export default function BatchSummaryStats({ id, isSuperAdmin = false }) {
  const {
    totalTransactions,
    successCount,
    pendingCount,
    failedCount,
    isLoading,
    isError,
    refetch,
  } = useBatchDetail(id, isSuperAdmin);

  const cards = [
    {
      icon: <HiOutlineDocumentText className="text-primary-700" />,
      iconBgClass: "bg-primary-100",
      label: "Total Transactions",
      value: getDisplayValue(totalTransactions),
      errorMessage: "Failed to load total transactions.",
    },
    {
      icon: <HiOutlineCheckCircle className="text-success-700" />,
      iconBgClass: "bg-success-100",
      label: "Success",
      value: getDisplayValue(successCount),
      errorMessage: "Failed to load success count.",
    },
    {
      icon: <HiOutlineClock className="text-warning-700" />,
      iconBgClass: "bg-warning-100",
      label: "Pending",
      value: getDisplayValue(pendingCount),
      errorMessage: "Failed to load pending count.",
    },
    {
      icon: <HiOutlineExclamationTriangle className="text-error-700" />,
      iconBgClass: "bg-error-100",
      label: "Failed",
      value: getDisplayValue(failedCount),
      errorMessage: "Failed to load failed count.",
    },
  ];

  return (
    <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
      {cards.map((card) => (
        <BulkStatCard
          key={card.label}
          icon={card.icon}
          iconBgClass={card.iconBgClass}
          label={card.label}
          value={card.value}
          isLoading={isLoading}
          isError={isError}
          onRetry={refetch}
          errorMessage={card.errorMessage}
        />
      ))}
    </div>
  );
}

BatchSummaryStats.propTypes = {
  id: PropTypes.string,
  isSuperAdmin: PropTypes.bool,
};
